// extracted by mini-css-extract-plugin
export default {"article":"article-view_article__Omqu9","downloadPdfButton":"article-view_downloadPdfButton__oIa+p"};